// extracted by mini-css-extract-plugin
export var alignLeft = "s_p5 d_bC";
export var alignCenter = "s_bL d_bz";
export var alignRight = "s_p6 d_bD";
export var hoursInnerWrapperAlt = "s_rg d_d7 d_L d_W d_bw d_bz d_bL d_df";
export var hoursInnerWrapperLeft = "s_rh d_d8 d_d7 d_L d_W d_bw d_bz d_bL d_b2 d_df";
export var hoursText = "s_rj d_ds";
export var titleMargin = "s_rk d_cs";
export var hoursInnerInnerWrapper = "s_rl d_cw";